import { db } from "../firebase";
import Firebase from "firebase";

// Example get document
export const getDateDishes = (doc_id_1, doc_id_2, callback) => {

	let docRef = db.collection("example").doc(doc_id_1).collection("example").doc(doc_id_2)

	docRef.get().then(function (doc) {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback();
        } else{
            callback(false);
        }
	});
};

// Example get collection
export const getSupersets = (callback) => {

	let docRef =  db.collection("workouts").doc("QAMiB0ri6Fxn5U6y791Z")
    
	docRef.get().then(function (doc) {
        
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
	});
};


export const getLatestProgress = (clientId, callback) => {
//   console.log('---->>>>Get: getLatestProgress');
  let formsRef =  db.collection('clients').doc(clientId).collection('measurements')

  formsRef.get().then(querySnapshot => {
    if (querySnapshot.size > 0) {
      let _push = [];
      querySnapshot.docs.map((_doc) => {
        //  console.log(_doc.data())

          _push.push(_doc.data());  
      }); 
      callback(_push[_push.length - 1]);
    } else {
      callback(false);
    }
  })
}

export const getPhases = (client_id, callback) => {

	let docRef =  db.collection("clients").doc(client_id).collection("phases")
    
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let data = [];

            querySnapshot.docs.map(doc => {
                data.push(doc.data());
            })

            callback(data);
        }else{
            callback(false);
        }
	});
};

// Example get collection
export const getFormsAurum = (callback) => {
	let docRef =  db.collection("forms")
	docRef.get().then(function (querySnapshot) {
        Promise.all(querySnapshot.docs.map( async(doc) => {
            let _sub_forms = []
             let sub_querySnapshot = await db.collection("forms").doc(doc.id).collection("sub_forms").get()
             if(sub_querySnapshot.size > 0){
                sub_querySnapshot.docs.map((sub_doc) => {
                    let _sub_push = sub_doc.data(); _sub_push.id = sub_doc.id
                    _sub_forms.push(_sub_push);
                })
             }else{
                _sub_forms = false
             }
            
            // _sub_forms.sort((a, b) => item_order.indexOf(a.name) - item_order.indexOf(b.name));
            let _push = {}; _push = doc.data(); _push.id = doc.id; _push.sub_forms = _sub_forms
            return _push
        })).then(result => {
            let _data = result.sort((a, b) => {
                let one = a.sub_forms.length ? a.sub_forms.length : 0
                let other = b.sub_forms.length ? b.sub_forms.length : 0
                return other - one
            })
            let item_order = ["Nutrition", "Lifestyle", "Goals", "Medical", "Coach"];
            //console.log();
            _data[0].sub_forms.sort((a, b) => item_order.indexOf(a.name) - item_order.indexOf(b.name))

            callback(_data);
        })
	});
};

export const getFormsCoach = (uid, callback) => {
	let docRef =  db.collection("coaches").doc(uid).collection("forms")
	docRef.get().then(function (querySnapshot) {
        Promise.all(querySnapshot.docs.map( async(doc) => {
            let _sub_forms = []
             let sub_querySnapshot = await db.collection("coaches").doc(uid).collection("forms").doc(doc.id).collection("sub_forms").get()
             if(sub_querySnapshot.size > 0){
                sub_querySnapshot.docs.map((sub_doc) => {
                    let _sub_push = sub_doc.data(); _sub_push.id = sub_doc.id
                    _sub_forms.push(_sub_push);
                })
             }else{
                _sub_forms = false
             }

             // let item_order = ["Nutrition", "Lifestyle", "Goals", "Medical", "Coach"];
             // _sub_forms.sort((a, b) => item_order.indexOf(a.name) - item_order.indexOf(b.name));

            let _push = {}; _push = doc.data(); _push.id = doc.id; _push.sub_forms = _sub_forms
            return _push
        })).then(result => {
            let _data = result.sort((a, b) => {
                let one = a.sub_forms.length ? a.sub_forms.length : 0
                let other = b.sub_forms.length ? b.sub_forms.length : 0
                return other - one
            })
            callback(_data);
        })
	});
};

// get form answers
export const getCLientFormResponse = (uid, callback) => {
    let docRef =  db.collection("clients").doc(uid).collection("intake_form");
    let docRefDuo =  db.collection("clients").doc(uid).collection("feedback_form");

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let data = [];

            querySnapshot.docs.map(doc => {
                data.push(doc.data());
            })

            docRefDuo.get().then((querySnapshot) => {
                if(querySnapshot.size > 0){
                    // let _push = {goals: doc.data().goals.form, lifestyle: doc.data().lifestyle.form, medical: doc.data().medical.form, nutrition: doc.data().nutrition.form, feedback_form: duo.data()} 
                    // callback(_push);
                    querySnapshot.docs.map(docDuo => {
                        data.push({...docDuo.data(), name: "feedback_form"});
                    })
                }
            })
            callback(data);
        }else{
            callback(false);
        }
	});
};

// get tag
export const getTags = (callback) => {

	let docRef =  db.collection("tags")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                _data.push({id: doc.id, name: doc.data().name})
            })
            callback(_data);
        } else{
            callback([]);
        }
	});
};

export const updateDB = (callback) => {
    let docRef =  db.collection("exercises");
    docRef.where('category', '==', 'Corrective Exercise').get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []; let __data = '';
            querySnapshot.docs.map(doc => {
                __data = doc.data();
                __data.category = (__data.category == 'Corrective Exercise') ? 'Remedial' : __data.category;
               //docRef.doc(doc.id).update(__data);
                //_data.push({id: doc.id, data: doc.data() });
            });
            console.log(_data);

            //_data[0].data.starts_with = (_data[0].data.starts_with == 'Up') ? 'Concentric' : 'Eccentric';
            //console.log(_data[0]);
            //docRef.doc(_data[0].id).update(_data[0].data);
            // docRef.update(content).then(() => {
            //       callback(true);
            // }).catch((error) => {
            //       callback(false);
            // });
            // console.log(_data[0]);
            // //callback(_data);
        } else{
            callback([]);
        }
    });
};

export const getExercisesAurum = (callback, category = false) => {
	let docRef =  db.collection("exercises");
    if(category && category != 'All'){
        docRef.where('category', '==', category).get().then((querySnapshot) => {
            if(querySnapshot.size > 0){
                let _data = []
                querySnapshot.docs.map(doc => {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                })
                callback(_data);
            } else{
                callback(false);
            }
        });
    } else {
        docRef.get().then((querySnapshot) => {
            if(querySnapshot.size > 0){
                let _data = []
                querySnapshot.docs.map(doc => {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                })
                callback(_data);
            } else{
                callback(false);
            }
        });
    }	
};

export const getExercise = (id, callback) => {
    db.collection("exercises").doc(id).get().then(function (doc) {
      if(doc.exists){
        let data = doc.data();
        data.id = doc.id;
        callback(data);
      } else{
        callback(false);
      }
    });



    // if (!doc.exists) {
    //   callback(false);
    // } else {
    //     callback(doc.data());
    // }
};

export const getProgramsAurum = (callback) => {

	let docRef =  db.collection("programs")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getProgramsWorkoutAurum = (programID, callback) => {

	let docRef =  db.collection("programs").doc(programID).collection('workouts')
	docRef.orderBy('name', 'asc').get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getExercisesCoach = (uid, callback, category = false) => {
    let docRef =  db.collection("coaches").doc(uid).collection("exercises");
    if(category && category != 'All'){
        docRef.where('category', '==', category).get().then((querySnapshot) => {
            if(querySnapshot.size > 0){
                let _data = []
                querySnapshot.docs.map(doc => {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                })
                callback(_data);
            } else{
                callback(false);
            }
        });
    } else {
        docRef.get().then((querySnapshot) => {
            if(querySnapshot.size > 0){
                let _data = []
                querySnapshot.docs.map(doc => {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                })
                callback(_data);
            } else{
                callback(false);
            }
        });
    }
	
};

export const getProgramsCoach = (uid, callback) => {

	let docRef =  db.collection("coaches").doc(uid).collection("programs")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getProgramsWorkoutCoach = (uid, programID, callback) => {

	let docRef =  db.collection("coaches").doc(uid).collection("programs").doc(programID).collection("workouts")
	docRef.orderBy('name', 'asc').get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getWorkoutsAurum = (callback) => {

	let docRef =  db.collection("workouts")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getWorkoutsCoach = (uid, callback) => {

	let docRef =  db.collection("coaches").doc(uid).collection("workouts")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback([]);
        }
	});
};  

export const getWorkoutFromClient = (client_id, time, callback) => {
    let docRef = db.collection("clients").doc(client_id).collection("workouts").doc(time);
    docRef.get().then(function (doc) {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
	});
}

export const getMealplansAurum = (callback) => {
	let docRef =  db.collection("mealplans")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getMealplansCoach = (uid, callback) => {
	let docRef =  db.collection("coaches").doc(uid).collection("mealplans")
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const getMealplanFromClient = (client_id, time, callback) => {

    let docRef = db.collection("clients").doc(client_id).collection("mealplans").doc(time);
    docRef.get().then(function (doc) {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
	});
}


export function getUserById(uid, callback) {
    db.collection("coaches")
      .doc(uid)
      .get()
      .then(function (doc) {
          if(doc.exists){
            let data = doc.data();
            data.id = doc.id;
            callback(data);
          }else{
            callback(false);
          }

      });
  }


  export const getClients = (uid, callback) => {
	let docRef =  db.collection("clients").where("coach", "==", uid)
	docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};




export const getCLientByName = (first_name, last_name, callback) => {
    let docRef = db.collection("clients").where("first_name", "==", first_name).where("last_name", "==", last_name);
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
}

export const getCLientById = (client_id, callback) => {
    let docRef = db.collection("clients").doc(client_id);
    docRef.get().then(function (doc) {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
	});
}

// todo: add coach id
export const getClientByNameParts = (first_name, last_name, coach_id, callback) => {
    let docRef = db.collection("clients").where("first_name", "==", first_name).where("last_name", ">=", last_name).where("last_name", "<=", last_name+ '\uf8ff');
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                if(doc.data().coach === coach_id) {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)   
                }
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
}

export const getClientByFirstName = (first_name, coach_id, callback) => {
    let docRef = db.collection("clients").where("first_name", '>=', first_name).where('first_name', '<=', first_name+ '\uf8ff');
    let _data = [];
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            querySnapshot.docs.map(doc => {
                if(doc.data().coach === coach_id) {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                }  
            })
        }
	});

    let docRef2 = db.collection("clients").where("last_name", '>=', first_name).where('last_name', '<=', first_name+ '\uf8ff');
    docRef2.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            querySnapshot.docs.map(doc => {
                if(doc.data().coach === coach_id) {
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    _data.push(_push)
                }  
            })
            callback(_data);
        } else{
            callback(false);
        }
	});

}


export const chatListener = (counter, client_id, callback) => {
    let docRef =  db.collection("clients").doc(client_id).collection("Chat").orderBy("created", "asc").limitToLast(counter)

	return docRef.onSnapshot((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push)
            })
            callback(_data);
        } else{
            callback(false);
        }
	});
};

export const isTypingListener = (client_id, callback) => {
    let docRef =  db.collection("clients").doc(client_id).collection("Chat").doc("is_typing")

	return docRef.onSnapshot((doc) => {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
	});
};

// getAllMessages(matchId: string) {
//     this.chatSvc.getAllMessages(matchId)
//       .orderBy('createdAt', 'asc')
//       .limitToLast(5)
//       .onSnapshot((snapshot) => {
//         snapshot.docChanges().forEach((change) => {
//           // push only new documents that were added
//           if(change.type === 'added'){
//            this.messages.push(change.doc.data());
//           }
//         });
//       });
//   }

// get previous measurements
export const getPreviousMeasurements = (client, currentTime, callback) => {
    
    let time;
    if(client.measurements?.time) {
        time = client.measurements.time
    }else {
        time = new Date(currentTime).getTime()/1000;
    }

    let docRef = db.collection("clients").doc(client.id).collection("measurements").where('time', "<", time).orderBy("time", "asc").limitToLast(1);
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                _data.push({id: doc.id, bmi: doc.data().bmi, weight: doc.data().weight, length: doc.data().length, bodyfat: doc.data().bodyfat})
            })
            callback(_data);
        } else{
            callback([]);
        }
    }); 
};

// get mealProgress for a specific day
export const getDailyMealProgress = (client_id, time, callback) => {
    // debugger
    let docRef = db.collection("clients").doc(client_id).collection("mealplans").doc(time);

    return docRef.onSnapshot((doc) => {
        // debugger
        if(doc.exists){
            // debugger
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            // debugger
            callback(false);
        }
    });
}

//get melaplan by date
export const getMealplanByDate = (client_id, date, callback) => {
    debugger
    console.log('---->>>>Get: getMealplanByDate');
    let mealplanRef = db.collection('clients').doc(client_id).collection('mealplans').doc(date);
  
    mealplanRef.get().then(doc => {
        debugger
      if (doc.exists) {
        debugger
        callback({...doc.data(), id: doc.id});
      } else {
        debugger
        callback(false);
      }
    });
  };

// get workout progress for a specific day
export const getDailyWorkoutProgress = (client_id, time, callback) => {
    let docRef = db.collection("clients").doc(client_id).collection("workouts").doc(time);

    return docRef.onSnapshot((doc) => {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            callback(false);
        }
    }); 
}
// get pendinclients
export const getPendingInvites = (coachId, callback) => {
    console.log('---->>>>Get: getPendingInvites');
    let pendingRef = db.collection('pending_clients').where('coach_id', '==', coachId);
  
    pendingRef.get().then(querySnapshot => {
      if (querySnapshot.size > 0) {
        let _push = [];
        querySnapshot.docs.map(_doc => {
          //  console.log(_doc.data())
  
          _push.push(_doc.data());
        });
        callback(_push);
      } else {
        callback(false);
      }
    });
  };

//get Meal plan for user
  export const getAllMealplansForUser = (client_id, callback) => {
    console.log('---->>>>Get: getAllMealplansForUser');
    let mealplanRef = db.collection('clients').doc(client_id).collection('mealplans');
  
    mealplanRef.get().then(querySnapshot => {
      let _data = [];
      if (querySnapshot.docs.length > 0) {
        querySnapshot.docs.map(doc => {
          _data.push({date: doc.id, ...doc.data()});
        });
        callback(_data);
      } else {
        callback(false);
      }
    });
  };

//get all progress for user
 export const getAllProgressForUser = (client_id, callback) => {
    console.log('---->>>>Get: getAllMeasurementForUser');
    let measurementRef = db.collection('clients').doc(client_id).collection('measurements');
  
    measurementRef.get().then(querySnapshot => {
      let _data = [];
      if (querySnapshot.docs.length > 0) {
        querySnapshot.docs.map(doc => {
          _data.push({date: doc.id, ...doc.data()});
        });
        callback(_data);
      } else {
        callback(false);
      }
    });
  };
// get workouts dates for calender
  export const getWorkoutsForUser = (client_id, callback) => {
    console.log('---->>>>Get: getAllMeasurementForUser');
    let workoutRef = db.collection('clients').doc(client_id).collection('workouts');
  
    workoutRef.get().then(querySnapshot => {
      let _data = [];
      if (querySnapshot.docs.length > 0) {
        querySnapshot.docs.map(doc => {
          _data.push({date: doc.id, ...doc.data()});
        });
        callback(_data);
      } else {
        callback(false);
      }
    });
  };

  // get tasks by Date ID
  export const getCoachesTaskItem = (coach_id, date_id, callback) => {
    // console.log('---->>>>Get:getCoachesCalendarItemsDates');
    let taskItemRef = db.collection('coaches').doc(coach_id).collection('calendar').doc(date_id).collection("tasks");
    taskItemRef.get().then((querySnapshot)=>{
        let _data = [];
              if (querySnapshot.docs.length > 0) {
                  querySnapshot.docs.map(doc => {
                    // console.log("data tasks",doc)
                  _data.push({date: doc.id, ...doc.data()});
                });
                callback(_data);
              } else {
                callback(false);
              }
    })
  };
  export const getCoachesClientsItem = (coach_id, date_id, callback) => {
    // console.log('---->>>>Get:getCoachesCalendarClietsItemsDates');
    let taskItemRef = db.collection('coaches').doc(coach_id).collection('calendar').doc(date_id).collection("clients");
    taskItemRef.get().then((querySnapshot)=>{
        let _data = [];
              if (querySnapshot.docs.length > 0) {
                  querySnapshot.docs.map(doc => {
                    // console.log("data tasks",doc)
                  _data.push({date: doc.id, ...doc.data()});
                });
                callback(_data);
              } else {
                callback(false);
              }
    })
  };
  export const geClientsChats = (client_id, callback) => {
    // console.log('---->>>>Get:getSortedChat');
    let taskItemRef = db.collection('clients').doc(client_id).collection("Chat");
    taskItemRef.get().then((querySnapshot)=>{
        let _data = [];
              if (querySnapshot.docs.length > 0) {
                  querySnapshot.docs.map(doc => {
                    // console.log("data tasks",doc)
                  _data.push({date: doc.id, ...doc.data()});
                });
                callback(_data);
              } else {
                callback(false);
              }
    })
  };

  export const getCoachesCalendarItemsDates = (coach_id, callback) => {
    // console.log('---->>>>Get:getCoachesCalendarItemsDates');
    let calendarRef = db.collection('coaches').doc(coach_id).collection('calendar');
  
    calendarRef.get().then(querySnapshot => {
      let _data = [];
      if (querySnapshot.docs.length > 0) {
          querySnapshot.docs.map(doc => {
            // console.log("data tasks",doc)
          _data.push({date: doc.id, ...doc.data()});
        });
        callback(_data);
      } else {
        callback(false);
      }
    });
  };

  
export const getLogs = (client_id, date, callback) => {
  let docef = db.collection('clients').doc(client_id).collection('workouts').doc(date).collection('logs');

  docef.get().then(querySnapshot => {
    let _data = {};
    if (querySnapshot.docs.length > 0) {
      querySnapshot.docs.map(doc => {
        let __data = doc.data();
        if(typeof __data.exId !== undefined){
          _data[__data.exId]  = {id: doc.id, ...doc.data()};
        }
      });
      callback(_data);
    } else {
      callback(false);
    }
  });
};


// get measurements for a specific day
export const getDailyMeasurementProgress = (client_id, time, currentTime, callback) => {
    let docRef = db.collection("clients").doc(client_id).collection("measurements").doc(time);

    return docRef.onSnapshot((doc) => {
        if(doc.exists){
            let _push = {}; _push = doc.data(); _push.id = doc.id;
            callback(_push);
        } else{
            docRef = db.collection("clients").doc(client_id);
            docRef.onSnapshot((doc) => {
                if(doc.exists && time < currentTime){
                    let _push = {}; _push = doc.data(); _push.id = doc.id;
                    callback(_push.measurements);
                } else{
                    callback(false);
                }
            });
        }
    });
    
}

// get 3 last days of measurements
export const getThreeLastDaysMeasurementProgress = (client_id, callback) => {
    let docRef = db.collection("clients").doc(client_id).collection("measurements").orderBy("time", "desc")
    .limit(3);

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })
            _data.reverse();
            callback(_data);
        } else{
            callback(false);
        }
	}); 
}

export const getMultipleDaysMeasurementProgress = (client_id, amountOfDays, callback) => {
    let docRef = db.collection("clients").doc(client_id).collection("measurements").orderBy("time", "desc")
    .limit(amountOfDays);

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })
            _data.reverse();
            callback(_data);
        } else{
            callback(false);
        }
	}); 
}

export const getAllMeasurementsForCalendar = (client_id, callback) => {
//   console.log('---->>>>Get: getAllMeasurementsForCalendar');
  let measurementsRef = db.collection('clients').doc(client_id).collection('measurements');

  measurementsRef.get().then(querySnapshot => {
    let _data = [];
    if (querySnapshot.docs.length > 0) {
      querySnapshot.docs.map(doc => {

        _data.push({date: doc.id, ...doc.data()});
      });
      _data = _data.sort(function(a,b){
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.date) + new Date(a.date);
      });

      callback(_data);
    } else {
      callback(false);
    }
  });
};

// get invoices of coach
export const getCoachesInvoices = (uid, callback) => {
    let docRef = db.collection("coaches").doc(uid).collection("invoices");

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })
            callback(_data);
        } else{
            callback(false);
        }
	}); 
}

export const getAllCoaches = (callback) => {
    let docRef = db.collection("coaches");

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })
            callback(_data);
        } else{
            callback(false);
        }
	}); 
}

export const getAllClients = (callback) => {
    let docRef = db.collection("clients");

    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })
            callback(_data);
        } else{
            callback(false);
        }
    }); 
}

// get calendar items of coach
export const getCalendarCoach = (uid, time, callback) => {
    let docRef = db.collection("coaches").doc(uid).collection("calendar").doc(time);

    return docRef.onSnapshot((doc) => {
        if(doc.exists){
            let _data = [];
            
            let docRefClients = db.collection("coaches").doc(uid).collection("calendar").doc(time).collection("clients");
            let docRefTasks = db.collection("coaches").doc(uid).collection("calendar").doc(time).collection("tasks");

            docRefClients.get().then((querySnapshot) => {
                if(querySnapshot.size > 0){
                    querySnapshot.docs.map(doc => {
                        let _push = {}; _push = doc.data(); _push.id = doc.id;
                        _data.push(_push);
                    })
                }
            }); 

            docRefTasks.get().then((querySnapshot) => {
                if(querySnapshot.size > 0){
                    querySnapshot.docs.map(doc => {
                        let _push = {}; _push = doc.data(); _push.id = doc.id;
                        _data.push(_push);
                    })
                }
                callback(_data);
            }); 
        } else{
            callback(false);
        }
    });
}

// get log history
export const getLogsHistory = (client_id, exerciseId, callback) => {
    // debugger
    // console.log('---->>>>Get: getLogsHistory');
    let docef = db.collection('clients').doc(client_id).collection('setshistory').doc(exerciseId);
    docef.get().then(doc => {
        // debugger
      if (doc.exists) {
        // debugger
        callback(doc.data());
      } else {
        // debugger
        callback(false);
      }
    });
}


// get clients who need action
export const getClientsWhoNeedAction = (coach_id, time, callback) => {
    let docRef = db.collection("clients").where("coach", "==", coach_id);

    // get all clients
    docRef.get().then((querySnapshot) => {
        if(querySnapshot.size > 0){
            let _data = []
            querySnapshot.docs.map(doc => {
                let _push = {}; _push = doc.data(); _push.id = doc.id;
                _data.push(_push);
            })

            // add to callback
            let clientsWhoNeedMealplan = [];
            let clientsWhoNeedWorkout = [];
            _data.forEach(element => {
                // check each client for mealplan
                let clientRef = db.collection("clients").doc(element.id).collection("mealplans").doc(time);
                
                clientRef.onSnapshot((doc) => {
                    if(!doc.exists) {
                        let mealPlan = {
                            user: element,
                            mealplan: 'Meal'
                        }
                        clientsWhoNeedMealplan.push(mealPlan)
                    }
                });
               
                // check each client for workout
                let clientRef2 = db.collection("clients").doc(element.id).collection("workouts").doc(time);

                clientRef2.onSnapshot((doc) => {
                    if(!doc.exists) {
                        let workout = {
                            user: element,
                            workout: 'Workout'
                        }
                        clientsWhoNeedWorkout.push(workout)
                    }
                });
            });

            let finalisedData = {
                missingMealplan: clientsWhoNeedMealplan,
                missingWorkout: clientsWhoNeedWorkout
            };
            callback(finalisedData);
        } else{
            callback(false);
        }
	}); 
}